// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SmallSocialCard-wrapper_a644fee4","friends":"SmallSocialCard-friends_3d502d02","iconsWrapper":"SmallSocialCard-iconsWrapper_dcf4bed1"};